<template>
  <a
    class="
      layout/inline-flex
      link/focus:children
    "
    :href="linkUrl"
    :data-gtm="gtm" 
    data-moma-link="icon"
    >
    <span 
      class="link/focus" 
      v-html="svgContent"
   />
  </a>
</template>

<script>
  import { addSvgToEnd } from 'Helpers/embedSVG';
  import { MoMABalanceText } from 'sol';

  export default {
    props: {
      external: {type: Boolean, required: true },
      linkUrl: {type: String, required: true },
      text: {type: String, required: true },
      gtm: {type: String, required: true },
    },
    data: function() {
      return {
        balanceText: new MoMABalanceText(),
      };
    },
    computed: {
      svgContent() {
        return addSvgToEnd(this.text, this.textClasses, "icon__arrow--16--stroke.svg", this.svgClass);
      },
      textClasses() {
        return `$typography/weight:bold typography ${this.balanceText.toggleBalanceTextClass(this.text)}`;
      },
      hash() {
        if (this.linkUrl) {
          return this.linkUrl.substring(0, 1) === '#';
        }
        return false;
      },
      svgClass() {
        if (this.external) {
          return 'typography/icon:after:315deg';
        }
        if (this.hash) {
          return 'typography/icon:after:90deg';
        }
        return 'typography/icon:after';
      },
    },
  }
</script>

